import React from 'react';
import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const TermFeeCollectionNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const redirectUrl = `${phpNavigationUrl}/student/term_fee_collection`;
  return <NavigationModel redirectUrl={redirectUrl} title="Term Fee Collection" navigationTo={'Old Portal'} />;
};

export default TermFeeCollectionNavigation;
